import { ConfigProvider, FormListOperation, Modal } from 'antd';
import en_US from 'antd/lib/locale/en_US';
import { enUSIntl, ProConfigProvider } from '@ant-design/pro-provider';
import { ActionType, FormListActionType, PageContainer, ProFormInstance } from '@ant-design/pro-components';
import { createContext, useEffect, useRef, useState } from 'react';
import { atom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import axiosApiInstance from '../api/axiosClient';
import DigitalAssetsTable from './Components/DigitalAssetsTable';
import SearchForm from './SearchForm';


type PageContext = {
    stepFormRef?: React.MutableRefObject<ProFormInstance>;
    firstFormPageRef?: React.MutableRefObject<ProFormInstance>;
    secondFormPageRef?: React.MutableRefObject<ProFormInstance>;
    listRef?: React.MutableRefObject<FormListActionType>;
    releasesActionRef?: React.MutableRefObject<ActionType>;
    artists?: SelectedArtistsByCategory;
    setArtists?: React.Dispatch<React.SetStateAction<SelectedArtistsByCategory>>;
    trackAction?: ProFormListRowAction;
    setTrackAction?: React.Dispatch<React.SetStateAction<ProFormListRowAction>>;
};

type ProFormListRowAction = FormListOperation & {
    getCurrentRowData: () => any;
    setCurrentRowData: (data: any) => void;
};

type SelectedArtistsByCategory = {
    main_artists?: string[];
    featuring_artists?: string[];
    composers?: string[];
    authors?: string[];
    remixers?: string[];
    producers?: string[];
    arrangers?: string[];
    publishers?: string[];
};

export const SearchPageContext = createContext<PageContext>({});

export const PageContextProvider = ({ children }: any) => {
    const stepFormRef = useRef<ProFormInstance>();
    const firstFormPageRef = useRef<ProFormInstance>();
    const secondFormPageRef = useRef<ProFormInstance>();
    const listRef = useRef<FormListActionType>();
    const [artists, setArtists] = useState<SelectedArtistsByCategory>({});
    const [trackAction, setTrackAction] = useState<ProFormListRowAction>();
    const releasesActionRef = useRef<ActionType>();

    return (
        <SearchPageContext.Provider
            value={{
                stepFormRef,
                firstFormPageRef,
                secondFormPageRef,
                listRef,
                releasesActionRef,
                artists,
                setArtists,
                trackAction,
                setTrackAction
            }}>
            {children}
        </SearchPageContext.Provider>
    );
};

export const isModalOpenAtom = atom(false);

const SearchAsset = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <ConfigProvider locale={en_US}>
                <PageContainer
                contentWidth={'Fluid'}
                >
                <SearchForm />
                <DigitalAssetsTable 
                 />
                 </PageContainer>
            </ConfigProvider>
        </>
    );
};

export default SearchAsset;
